import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectSubsidiaryModal from "../../../components/SelectSubsidiary.modal";
import LoginModal from "../../../components/Login.modal";
import MainModal from "../../../components/Main.modal";
import MessageBox from "../../../components/MessageBox";
import AvisoConfigPendente from "../../../components/AvisoConfigPendente";
import { useConfigDoPdv } from "../../../hooks/useConfigDoPdv";
import { decodeToken } from "../../../services/jwt-decode.service";
import api from "../../../services/api.service";
import { normalizarEnderecoDaApi } from "../../../services/enderecoApi.service";
import {
  AccessButton,
  AccessButtonsContainer,
  AlfredoIcon,
  ChooseOption,
  LogButton,
  PageContainer,
  SaleOptionImg,
} from "../styles/Home.styles";
import { useCombinedStore } from "../../../store";
import { lerDimensaoDaConfig } from "../../../dominio/dimensaoDaConfig";
import { lerSituacaoDaHome } from "../../../dominio/orientacaoDaHome";
import OrientacaoDaHome from "./OrientacaoDaHome";
import tableSvg from "../../../assets/table.svg";
import counterSvg from "../../../assets/counter.svg";
import deliverySvg from "../../../assets/delivery.svg";

const Homepage = () => {
  const [displayModalSelectSubsidiary, setDisplayModalSelectSubsidiary] = useState(false);
  const [displayModalLogin, setDisplayModalLogin] = useState(false);
  const [displayModalMain, setDisplayModalMain] = useState(false);
  const navigate = useNavigate();

  const { subsidiaryDataZustand, authUserZustand } = useCombinedStore();

  const {
    setAuthUserZustand,
    removeAuthUserZustand,
    setSubsidiaryDataZustand,
    setMessageZustand,
    setOrderDataZustand,
    orderDataZustand,
    setSelectedSectionZustand,
  } = useCombinedStore((state) => {
    return {
      setAuthUserZustand: state.setAuthUserZustand,
      removeAuthUserZustand: state.removeAuthUserZustand,
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      setMessageZustand: state.setMessageZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setSelectedSectionZustand: state.setSelectedSectionZustand,
    };
  });
  // Reconsulta a configuração deste PDV de tempos em tempos: quando a Central
  // manda alteração "para agora", a tela se atualiza sozinha, sem o operador
  // precisar recarregar ou re-selecionar o PDV.
  useConfigDoPdv();

  const handleModalMainClose = () => {
    setDisplayModalMain(false);
  };

  const handleModalLoginClose = () => {
    setDisplayModalLogin(false);
  };

  const handleLogin = async (userEmail: string, userPassword: string) => {
    try {
      const loginResponse = await api.post("/login", {
        userEmail,
        userPassword,
        expiresIn: "12h",
      });
      const decodedResponse: any = await decodeToken(
        loginResponse.data.authUser.Token
      );

      const userUpdatedinfo = {
        authUser: loginResponse.data.authUser.Token,
        userInfo: {
          userUuid: decodedResponse.userUuid,
          userEmail: decodedResponse.userEmail,
          userName:
            decodedResponse.userName === undefined
              ? ""
              : decodedResponse.userName,
          userSurName: decodedResponse.userSurname,
          userSocialName: decodedResponse.userSocialName,
          userLogoUrl:
            decodedResponse.userLogoUrl === null
              ? ""
              : decodedResponse.userLogoUrl,
          userStatus: decodedResponse.userStatus,
          userGroupType: decodedResponse.userGroupType,
          userGroupName: decodedResponse.userGroupName,
          userGroupStatus: decodedResponse.userGroupStatus,
          userGroupInfo: decodedResponse.userGroupInfo,
        },
      };
      setAuthUserZustand({
        ...userUpdatedinfo,
      });
      setDisplayModalLogin(false);
      handleSetMessage(
        `Bem vindo ao Alfredo,  ${userUpdatedinfo.userInfo.userSocialName}!`,
        `success`
      );
      const subsidiaryInfoResponse = await api.get("/subsidiaryInfo/1");
      const subsidiaryInfo = subsidiaryInfoResponse.data.subsidiaryInfo.map(
        (info: any) => {
          if (info.subsidiaryInfoType === 1) {
            return {
              ...info,
              subsidiaryInfoValue: JSON.parse(info.subsidiaryInfoValue),
            };
          }
          return info;
        }
      );

      const subsidiaryUpdatedInfo = {
        subsidiaryName: subsidiaryInfoResponse.data.subsidiary.subsidiaryName,
        subsidiaryLogoUrl:
          subsidiaryInfoResponse.data.subsidiary.subsidiaryLogoUrl,
        subsidiaryAddress:
          subsidiaryInfoResponse.data.subsidiary.subsidiaryAddress,
        subsidiaryTaxPayerID:
          subsidiaryInfoResponse.data.subsidiary.subsidiaryTaxPayerID,
        subsidiaryVirtualAddress:
          subsidiaryInfoResponse.data.subsidiary.subsidiaryVirtualAddress,
        subsidiaryManager:
          subsidiaryInfoResponse.data.subsidiary.subsidiaryManager,
        pdvs: subsidiaryInfoResponse.data.pdvs,
        subsidiaryInfo: subsidiaryInfo,
      };

      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        ...subsidiaryUpdatedInfo,
      });
    } catch (error: any) {
      setDisplayModalLogin(false);
      handleSetMessage(
        "Ocorreu um erro ao realizar o login: " + error.response.data.message,
        "error"
      );
    }
  };

  const handleSelectSubsidiary = async (subdiaryApiAddress: string) => {
    // Era sempre `http://${endereco}:9898`, o que só existe dentro da loja.
    // normalizarEnderecoDaApi mantém esse formato quando vem um IP puro e
    // respeita "https://..." quando a loja está publicada (nuvem/proxy).
    const subsidiaryCompleteApiAddress =
      normalizarEnderecoDaApi(subdiaryApiAddress);
    setSubsidiaryDataZustand({
      ...subsidiaryDataZustand,
      subsidiaryVirtualAddress: subsidiaryCompleteApiAddress,
    });
    setDisplayModalSelectSubsidiary(false);
    window.location.reload();
  };

  const handleModalSelectSubdiaryClose = () => {
    setDisplayModalSelectSubsidiary(false);
  };

  const handleClickLogButton = () => {
    if (authUserZustand) {
      removeAuthUserZustand();
    } else {
      setDisplayModalLogin(true);
    }
  };

  const handleClickLogoButton = () => {
    if (!subsidiaryDataZustand.subsidiaryVirtualAddress) {
      setDisplayModalSelectSubsidiary(true);
    }
    else if (authUserZustand) {
      setDisplayModalMain(true);
    } else {
      setDisplayModalLogin(true);
    }
  };

  const handleClickAccessPointOfSales = (sale_option: string) => {
    if (authUserZustand) {
      if (subsidiaryDataZustand.selectedPdv.selectedPeriod) {
        const saleOptionQueryParam = encodeURIComponent(sale_option);
        setOrderDataZustand({
          orderUuid: "",
          orderCode: "",
          orderOwnerUuid: "",
          orderOwnerName: "",
          orderStatus: 0,
          orderType: "",
          createdAt: "",
          orderInfo: {},
        });
        navigate(`point-of-sale/${saleOptionQueryParam}`);
      } else {
        setSelectedSectionZustand("Periodo");
        setDisplayModalMain(true);
      }
    } else {
      setDisplayModalLogin(true);
    }
  };

  const handleSetMessage = (message: string, messageType: string) => {
    if (!displayModalLogin || !displayModalMain) {
      setMessageZustand(message, messageType);
    }
  }

  // As quatro dimensões que vêm da configuração do PDV, lidas uma vez por
  // render (e não uma vez por botão de venda). Quem decide o que cada forma de
  // registro vira em CSS é `dominio/dimensaoDaConfig.ts`.
  const configDaHome = subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue;
  const larguraDoLogo = lerDimensaoDaConfig(configDaHome.logoWidth);
  const alturaDoLogo = lerDimensaoDaConfig(configDaHome.logoHeight);
  const larguraDoBotao = lerDimensaoDaConfig(configDaHome.buttonsWidth);
  const alturaDoBotao = lerDimensaoDaConfig(configDaHome.buttonsHeight);

  // O que a Home tem a DIZER agora. Todos os caminhos que faltam se resolvem
  // clicando no logo — que não parece um botão —, então a tela precisa dizer
  // isso em palavras. No estado pronto a situação é "pronto" e o cartão não
  // renderiza nada (`dominio/orientacaoDaHome.ts`).
  const opcoesDeVendaAtivas =
    subsidiaryDataZustand.selectedPdv.saleOptions?.filter(
      (opcao) => opcao.itemInfoStatus
    ).length ?? 0;
  const situacaoDaHome = lerSituacaoDaHome({
    temEnderecoDaLoja: Boolean(subsidiaryDataZustand.subsidiaryVirtualAddress),
    estaLogado: Boolean(authUserZustand),
    temCaixaEscolhido: Boolean(subsidiaryDataZustand.selectedPdv.itemUuid),
    periodoAberto: Boolean(subsidiaryDataZustand.selectedPdv.selectedPeriod),
    opcoesDeVendaAtivas,
  });

  return (
    <PageContainer
      backgroundColor={
        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue.backgroundColor
      }
    >
      <MessageBox />
      <AvisoConfigPendente />
      <AlfredoIcon
        larguraDoLogo={larguraDoLogo}
        alturaDoLogo={alturaDoLogo}
        src={subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue.logo}
        alt="Alfredo Icon"
        onClick={handleClickLogoButton}
      />
      {displayModalMain && (
        <MainModal isOpen={true} onRequestClose={handleModalMainClose} />
      )}
      <ChooseOption
        textColor={
          subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue.textColor
        }
      >
        {subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue.homeTitle}
      </ChooseOption>
      <OrientacaoDaHome situacao={situacaoDaHome} />
      {subsidiaryDataZustand.selectedPdv ? (
        <AccessButtonsContainer>
          {subsidiaryDataZustand.selectedPdv.saleOptions?.map(
            (option, index) => {
              if (option.itemInfoStatus) {
                return (
                  <AccessButton
                    key={index}
                    textColor={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .textColor
                    }
                    buttonsColor={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                    onClick={() =>
                      handleClickAccessPointOfSales(option.itemInfoUuid)
                    }
                    title={option.itemInfoValue.saleOptionName}
                    larguraDoBotao={larguraDoBotao}
                    alturaDoBotao={alturaDoBotao}
                  >
                    {Number(option.itemInfoValue.saleOptionType) === 1 && (
                      <SaleOptionImg
                        src={
                          option.itemInfoValue.saleOptionImg === "default"
                            ? tableSvg
                            : option.itemInfoValue.saleOptionImg
                        }
                        alt={option.itemInfoName}
                      />
                    )}
                    {Number(option.itemInfoValue.saleOptionType) === 2 && (
                      <SaleOptionImg
                        src={
                          option.itemInfoValue.saleOptionImg === "default"
                            ? counterSvg
                            : option.itemInfoValue.saleOptionImg
                        }
                        alt={option.itemInfoName}
                      />
                    )}
                    {Number(option.itemInfoValue.saleOptionType) === 3 && (
                      <SaleOptionImg
                        src={
                          option.itemInfoValue.saleOptionImg === "default"
                            ? deliverySvg
                            : option.itemInfoValue.saleOptionImg
                        }
                        alt={option.itemInfoName}
                      />
                    )}
                  </AccessButton>
                );
              }
              return null;
            }
          )}
        </AccessButtonsContainer>
      ) : null}
      <LogButton
        textColor={
          subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue.textColor
        }
        buttonsColor={
          subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue.buttonsColor
        }
        onClick={handleClickLogButton}
      >
        {authUserZustand ? "Encerrar" : "Acessar"}
      </LogButton>
      {displayModalLogin && (
        <LoginModal
          isOpen={true}
          onRequestClose={handleModalLoginClose}
          onLogin={handleLogin}
        />
      )}
      {displayModalSelectSubsidiary && (
        <SelectSubsidiaryModal isOpen={true}
          onRequestClose={handleModalSelectSubdiaryClose}
          onSelectSubsidiary={handleSelectSubsidiary}
        />
      )}
    </PageContainer>
  );
};

export default Homepage;
